import React, { useState } from "react";

import { useAuthentication } from "../../../../hooks";
import { useActions } from "../../../../provider";
import { parseMsisdn, STEPS_NAME } from "../../../../utils";

import {
  AddCardForm,
  MyCardsList,
  PaymentCardReceipt,
  SmsPhoneConfirmation,
} from "../../../../components";
import * as Styles from "./styles";

export const CREDIT_STEPS = {
  SMS_CONFIRM: "SMS_CONFIRM",
  CARDS_LIST: "CARDS_LIST",
  ADD_CARD: "ADD_CARD",
  RECEIPT: "RECEIPT",
};

export function CreditPaymentMethod() {
  const {
    actionsState,
    setIsLoading,
    setActionsState,
    stepManager,
    config,
  } = useActions();
  const { msisdn, plan, paymentData } = actionsState;
  const { authToken, isSmsTokenValid, handleGenerateSmsToken } =
    useAuthentication({ setIsLoading });
  const [currentStep, setCurrentStep] = useState(
    isSmsTokenValid(msisdn) ? CREDIT_STEPS.CARDS_LIST : CREDIT_STEPS.SMS_CONFIRM
  );

  return (
    <Styles.Container>
      {currentStep === CREDIT_STEPS.SMS_CONFIRM ? (
        <>
          <h1>Realize a confirmação de SMS</h1>
          <p>
            Insira o código de confirmação que foi enviado para o número{" "}
            {parseMsisdn(msisdn)}
          </p>
          <SmsPhoneConfirmation
            msisdn={msisdn}
            onValidate={() => {
              handleGenerateSmsToken(msisdn);
              setCurrentStep(CREDIT_STEPS.CARDS_LIST);
            }}
            authToken={authToken}
            setIsLoading={setIsLoading}
          />
        </>
      ) : currentStep === CREDIT_STEPS.CARDS_LIST ? (
        <>
          <h1>Selecione o cartão de crédito</h1>
          <MyCardsList
            msisdn={msisdn}
            onSelect={(cardData) => {
              setCurrentStep("RECEIPT");
              setActionsState({ paymentData: { card: cardData } });
            }}
            navigateToAddCard={() => setCurrentStep(CREDIT_STEPS.ADD_CARD)}
            setIsLoading={setIsLoading}
          />
        </>
      ) : currentStep === CREDIT_STEPS.ADD_CARD ? (
        <>
          <h1>Novo Cartão de crédito</h1>
          <AddCardForm
            onCancel={() => setCurrentStep(CREDIT_STEPS.CARDS_LIST)}
            onAddCard={() => setCurrentStep(CREDIT_STEPS.CARDS_LIST)}
            msisdn={msisdn}
            setIsLoading={setIsLoading}
          />
        </>
      ) : currentStep === CREDIT_STEPS.RECEIPT ? (
        <>
          <h1>Pagamento via cartão</h1>
          <PaymentCardReceipt
            plan={plan}
            msisdn={msisdn}
            paymentData={paymentData?.card}
            authToken={authToken}
            onChangeStep={stepManager.set}
            setIsLoading={setIsLoading}
            onPayment={() =>
              config.ALLOW_CHANGE_RECEIPT_DATA && stepManager.set(STEPS_NAME.CHOOSE_PLAN)
            }
            allowChangeData={config.ALLOW_CHANGE_RECEIPT_DATA}
            canMakeProgram={plan.enable_program && config.ALLOW_PROGRAM}
            successMessage={
              config.ALLOW_PROGRAM
                ? "Sua recarga será programada automáticamente a cada 30 dias a partir de hoje"
                : undefined
            }
          />
        </>
      ) : null}
    </Styles.Container>
  );
}
